import {Field, Typography} from "@bolteu/clay-react";

import * as Styled from "./fieldLabel.styled";

interface FieldLabelProps {
    label: string;
    subtitle?: string;
}

// Clay Field.Label so the label auto-associates with the field control (via Base UI's
// LabelableContext), plus an optional right-aligned subtitle (e.g. the description char
// counter). Render inside a Field.Root next to the control. Field.Root's own `required`
// prop drives Clay's automatic asterisk on Field.Label — nothing to wire up here.
export const FieldLabel = ({label, subtitle}: FieldLabelProps) => (
    <Styled.Split>
        <Field.Label className="bolt-font-body-s-accent pr-2">{label}</Field.Label>
        {!!subtitle && <Typography className="bolt-font-body-s-regular text-secondary">{subtitle}</Typography>}
    </Styled.Split>
);
